<template>
  <LcImage
    v-if="imageProps"
    v-bind="{ alt, densities, ...imageProps }"
    @load="emit('load')"
  />
</template>

<script lang="ts" setup>
export type IllustrationEmits = (event: 'load') => void

export type IllustrationProps = {
  alt?: string
  densities?: string
  name: string
}

const { alt = '', densities = '1x', name } = defineProps<IllustrationProps>()

const emit = defineEmits<IllustrationEmits>()

const { getIllustration } = useAsset()

const imageProps = computed(() => getIllustration(name))
</script>
